export default class SubscriberImportCtrl {
    constructor($scope, $state, $location, $window, $filter, Tag, SideMenu, Rest, Customization, SweetAlert, Subscriber, Events, Language) {
        SideMenu.setActive('subscriber');

        this._scope = $scope;
        this._state = $state;
        this._translator = $filter('translate');
        this._location = $location;
        this._window = $window;

        this.subscriberRepo = Subscriber;
        this.tagRepo = Tag;
        this.customRepo = Customization;
        this.eventHandler = Events;
        this.rest = Rest.rest;
        this.languageRepo = Language;
        this.alerter = SweetAlert;

        this.filename = false;
        this.importData = "";
        this.tags = [];
        this.numOfLines = 0;
        this.importFile = false;
        this.copyPaste = "";
        this.analyzedColumns = false;
        this.showSuppressionOverlay = false;
        this.importedPercent = 0;
        this.importColumns = [];
        this.autoMapColumns = [];
        this.currentImport = false;
        this.addingNewField = false;
        this.hasSuppression = false;
        this.customization = {
            groups: []
        };
        this.preferenceList = [];
        this.selectedPreferences = {
            list: []
        };
        this.preferences_opt_in = false;
        this.override_preferences = false;

        this.allowedFileFormats = ['txt', 'csv', 'xls', 'xlsx'];

        if (this._location.search().tagId) {
            this.tagRepo.find(this._location.search().tagId).then((tag) => {
                this.preloadedTag = tag.data;
            });
        }

        this._scope.$watch(angular.bind(this, () => this.importData), (data) => {
            if (data) {
                this.numOfLines = data.length > 0 ? data.split("\n").length : 0;
            }
        });

        this._scope.$watch(angular.bind(this, () => this.tags), (newVal) => {
            if (newVal && this.tags.length > 0) {
                this.tagRequired = false;
            }
        }, true);

        /**
         * Keep track of what custom fields is chosen, to prevent multiple columns of mapping to the same field.
         */
        this._scope.$watchCollection(angular.bind(this, () => this.importColumns), (newVal) => {
            angular.forEach(this.formattedFields, (field) => {
                let chosen = false;

                angular.forEach(newVal, (val) => {
                    if (val != 'ignore' && field.id == val) {
                        chosen = true;
                        field.chosen = true;
                    }
                });

                if (! chosen) {
                    let chosenInAutoMapColumns = false;

                    angular.forEach(this.autoMapColumns, (column) => {
                        if (column.field == field.id) {
                            chosenInAutoMapColumns = true;
                        }
                    });

                    if (! chosenInAutoMapColumns) {
                        field.chosen = false;
                    }
                }
            });
        });

        /**
         * Keep track of what custom fields is chosen, to prevent multiple columns of mapping to the same
         * field. Deep watch this array of objects.
         */
        this._scope.$watch(angular.bind(this, () => this.autoMapColumns), (newVal) => {
            angular.forEach(this.formattedFields, (field) => {
                let chosen = false;

                angular.forEach(newVal, (val) => {
                    if (val.field != 'ignore' && field.id == val.field) {
                        chosen = true;
                        field.chosen = true;
                    }
                });

                if (! chosen) {
                    let chosenInImportColumns = false;

                    angular.forEach(this.importColumns, (column) => {
                        if (column == field.id) {
                            chosenInImportColumns = true;
                        }
                    });

                    if (! chosenInImportColumns) {
                        field.chosen = false;
                    }
                }
            });

            this.checkSuppression();
        }, true);

        this._scope.$on('CustomField:Added', (event, newData) => {
            let field = newData.field.data ? newData.field.data : newData.field;

            this.formatAndAddField(
                field.name,
                newData.group.name,
                newData.group.id,
                newData.fieldType,
                field.id
            );

            this.updateGroups();

            this.eventHandler.flashEvent('notification', this._translator('CUSTOMIZE:FLASH:FIELD_CREATED'));
        });

        this.getPreferenceList();
    }

    openAddFieldModal() {
        this.addingNewField = true;
    };

    toggleAddSuppressionOverlay() {
        this._scope.$broadcast('import:add:suppression');
    };

    addAutoMapColumn() {
        this.autoMapColumns.push({ field: '', value: '' });
    };

    autoMapFieldSelect(field, column) {
        column.customField = field;

        if (field.typeId == 'multiple') {
            column.customField.fieldId = field.id;
            column.loadedOptions = false;
        }
    };

    deleteAutoMapColumn(index) {
        this.autoMapColumns.splice(index, 1);
    };

    getCustomizations() {
        this.customRepo.allGroups().then((groups) => {
            this.formattedFields = [];
            this.customization.groups = this.rest.stripRestangular(groups.data);
            this.setDefaultFields();
            this.setCustomizedFields();

            this.languageRepo.all().then((data) => {
                this.languages = data.languages;
            });

            // Auto-map analyzed columns first, because prioritized.
            this.columns.forEach((value, key) => {
                if (value == this.hasEmail.columnName) {
                    this.importColumns[key] = 'email';
                    this.setEmailChosen();
                } else {
                    this.importColumns[key] = 'ignore';
                }
            });

            // Loop again to give analyzed columns priority mapping for group.field and then another loop for the field.
            this.columns.forEach((value, key) => {
                if (value.split('.').length == 2) {
                    let groupName = value.split('.')[0];
                    let fieldName = value.split('.')[1];

                    this.formattedFields.forEach((field) => {
                        let fieldNameMatch = field.name.toUpperCase() == fieldName.toUpperCase();
                        let groupNameMatch = field.groupName && groupName ? field.groupName.toUpperCase() == groupName.toUpperCase() : false;

                        if (groupNameMatch && fieldNameMatch && ! field.chosen) {
                            this.importColumns[key] = field.id;
                            field.chosen = true;
                        }
                    });
                }
            });

            this.columns.forEach((value, key) => {
                if (value.split('.').length != 2) {
                    this.formattedFields.forEach((field) => {
                        let fieldNameMatch = field.name.toUpperCase() == value.toUpperCase();

                        if (fieldNameMatch && ! field.chosen) {
                            this.importColumns[key] = field.id;
                            field.chosen = true;
                        }
                    });
                }
            });
        });
    };

    setEmailChosen() {
        this.formattedFields.forEach((field) => {
            if (field.id == 'email') {
                field.chosen = true;
            }
        })
    };

    setCustomizedFields() {
        this.customization.groups.forEach((group) => {
            group.fields.forEach((field) => {
                this.formatAndAddField(
                    field.name,
                    group.name,
                    group.id,
                    field.type,
                    field.id
                );
            });
        });
    };

    setDefaultFields() {
        this.formatAndAddField(this._translator('SUBSCRIBER:IMPORT:IGNORE'), null, null, null, 'ignore');
        this.formatAndAddField(this._translator('GLOBAL:PHONE_NUMBER'), null, null, null, 'phone_number');
        this.formatAndAddField('Email', null, null, null, 'email');
        this.formatAndAddField(this._translator('GLOBAL:LANGUAGE'), null, null, null, 'language');
        this.formatAndAddField('Opt-in date', null, null, null, 'opted_in_at');
    };

    startOver() {
        this._window.location.reload();
    };

    formatAndAddField(name, groupName, groupID, type, id) {
        this.formattedFields.push({
            name: name,
            groupName: groupName,
            groupID: groupID,
            type: type ? this._translator('CUSTOM_FIELDS:TYPE:' + type.toUpperCase()) : type,
            typeId: type,
            id: id,
            chosen: false
        });

        this.formattedFields.sort(this.sortByGroup);
    };

    sortByGroup(group1, group2) {
        if (group1.groupID < group2.groupID) {
            return -1;
        }

        if (group1.groupID > group2.groupID) {
            return 1;
        }

        return 0;
    }

    clearImport() {
        this.analyzedColumns = false;
        this.importColumns = [];
        this.currentImport = false;
        this.importedPercent = 0;
        this.copyPaste = "";
        this.filename = false;
    };

    clearFileUpload() {
        this.importFile = null;
        angular.element('#subscriber-upload').val(null);
    };

    validateAutoMappings() {
        let success = true;

        if (this.autoMapColumns.length) {
            angular.forEach(this.autoMapColumns, (value) => {
                if (! value.field || ! value.value) {
                    success = false;
                }
            });
        }

        return success;
    };

    validateColumns() {
        let success = true;

        if (this.importColumns.length) {
            angular.forEach(this.importColumns, (value) => {
                if (! value) {
                    success = false;
                }
            });
        }

        return success;
    };

    formatColumns() {
        const columns = angular.copy(this.importColumns);

        const customFieldIds = this.customization.groups.map(({ fields }) => {
            return fields.map(({ id }) => id)
        }).flat();

        return columns.map((field, idx) => {
            if (customFieldIds.includes(field)) {
                return {
                    index: idx,
                    field_id: field,
                }
            } else if (field !== 'ignore') {
                return {
                    index: idx,
                    basic_field: field
                }
            }
        }).filter(Boolean)
    };

    formatAutoMappingColumns() {
        const defaultColumns = angular.copy(this.autoMapColumns);

        const customFieldIds = this.customization.groups.map(({ fields }) => {
            return fields.map(({ id }) => id)
        }).flat();

        return defaultColumns.map((column) => {
            if (customFieldIds.includes(column.field)) {
                return {
                    value: column.value?.length ? column.value.join('|') : column.value,
                    field_id: column.field,
                }
            } else if (column.field === 'rule_suppress') {
                return {
                    basic_field: column.field,
                    value: column.value
                }
            }
        }).filter(Boolean)
    };

    continueWithImport() {
        if (this.tags.length > 0) {
            if (! this.validateAutoMappings()) {
                return this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('SUBSCRIBER:IMPORT:INVALID_AUTO_MAPPING'),
                    type: 'error'
                });
            }

            if (! this.validateColumns()) {
                return this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('SUBSCRIBER:IMPORT:INVALID_AUTO_MAPPING'),
                    type: 'error'
                });
            }

            let data = {
                columns: this.formatColumns(),
                filename: this.filename,
                tags: this.tags.map(Number),
                default_columns: this.formatAutoMappingColumns()
            };


            if (this.selectedPreferences.list.length) {
                data.preferences = this.selectedPreferences.list.map(Number);
                data.preferences_opt_in = this.preferences_opt_in;
                data.override_preferences = this.override_preferences;
            }

            this.subscriberRepo.import(data).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('SUBSCRIBER:IMPORT:IMPORT_STARTED_DESCRIPTION'));
                this._state.go('subscriber.index');
            }, (error) => {
                this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('SUBSCRIBER:IMPORT:ERROR_EXPLAINED'),
                    type: 'error'
                });
            });
        } else {
            this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER:IMPORT:NO_TAG_CHOSEN'))
        }
    };

    uploadAndAnalyzeImport() {
        if (this.importFile) {
            if (!this.fileIsValid()) {
                return this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('SUBSCRIBER:IMPORT:ERROR_EXPLAINED'),
                    type: 'error'
                });
            }
            this.subscriberRepo.uploadImportFile(this.importFile).then((results) => {
                this.handleAnalyzedImport(this.normalizeUploadSubscribersResource(results.data))
            }, (error) => {
                if (error.status == 400) {
                    if (error.data.code == 7) {
                        return this.alerter.swal({
                            title: this._translator('GLOBAL:FLASH:OOPS'),
                            text: this._translator('SUBSCRIBER:IMPORT:MAX_ALLOWED_CONCURRENT_IMPORTS_EXCEEDED'),
                            type: 'error'
                        });
                    } else if (error.data.code == 6) {
                        return this.alerter.swal({
                            title: this._translator('GLOBAL:FLASH:OOPS'),
                            text: this._translator('SUBSCRIBER:IMPORT:ERROR_EXPLAINED'),
                            type: 'error'
                        });
                    }
                } else {
                    return this.alerter.swal({
                        title: this._translator('GLOBAL:FLASH:OOPS'),
                        text: this._translator('SUBSCRIBER:IMPORT:ERROR_EXPLAINED'),
                        type: 'error'
                    });
                }
            });
        } else if (this.copyPaste.length > 0) {
            this.subscriberRepo.uploadCopyPaste(this.copyPaste).then((results) => {
                this.handleAnalyzedImport(this.normalizeCopyPastSubscribersResource(results.data))
            }, (error) => {
                if (error.data.code == 7) {
                    this.alerter.swal({
                        title: this._translator('GLOBAL:FLASH:OOPS'),
                        text: this._translator('SUBSCRIBER:IMPORT:MAX_ALLOWED_CONCURRENT_IMPORTS_EXCEEDED'),
                        type: 'error'
                    });
                }
            })
        } else {
            this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER:IMPORT:NO_SUBSCRIBERS_FLASH'));
        }
    };

    handleAnalyzedImport(results) {
        this.analyzedColumns = results.columns;

        this.hasEmail = {
            columnName: undefined
        };

        angular.forEach(results.identified, (column) => {
            let key = Object.keys(column)[0];

            if (key == 'email') {
                this.hasEmail.columnName = column[key];
            }
        });

        this.filename = results.filename;
        this.columns = results.columns;
        this.getCustomizations();
    }

    updateGroups() {
        this.customRepo.allGroups().then((groups) => {
            this.customization.groups = this.rest.stripRestangular(groups.data);
        });
    };

    checkSuppression() {
        angular.forEach(this.autoMapColumns, (field) => {
            if (field.field === 'rule_suppress') {
                this.hasSuppression = field.value.length > 0;
            }
        });
    }

    static fieldTypeToInt(field) {
        let typesMap = {
            text: 1,
            single: 2,
            multiple: 3,
            json: 4,
            datetime: 5,
            date: 6,
            time: 7
        };

        return typesMap[field.type];
    }

    fileIsValid() {
        for (let i = 0; i < this.allowedFileFormats.length; i++) {
            let extension = `.${this.allowedFileFormats[i]}`;
            if (this.importFile && this.importFile.name.indexOf(extension) !== -1) {
                return true;
            }
        }
    }

    getAcceptString() {
        let accept = '';
        this.allowedFileFormats.forEach(format => {
           accept += `.${format}, `
        });
        return accept;
    }

    getPreferenceList() {
        this.customRepo.getPreferenceList().then(preferenceList => {
            this.preferenceList = preferenceList;
            this._scope.$apply();
        }).catch( error => {
            this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER:IMPORT:PREFERENCES:FETCH_ERROR'));
        });
    }

    normalizeCopyPastSubscribersResource(input) {
        const columns = input.data.map(item => {
            return item.records[0];
        }).filter(Boolean);

        const identified = input.identified.map(item => {
            const headerIndex = parseInt(item.header) - 1;
            const type = item.type;
            const value = input.data[headerIndex].records[0];

            return { [type]: value };
        });

        return {
            filename: input.filename,
            columns: columns,
            identified,
        };
    }


    normalizeUploadSubscribersResource(input) {
        const identified = input.identified.map(item => ({ [item.header]: item.type }));
        const data = input.data.reduce((acc, curr) => {
            acc[curr.header] = curr.records.slice(0, 3)
            return acc
        }, {})

        return {
            filename: input.filename,
            columns: input.headers,
            data,
            identified,
        };
    }

};
